export default __webpack_public_path__ + "50981686d5515f0d97e62c6dea10458c.png";